import React, { Component } from 'react';
import LongText from '../Utils/LongText';

class AboutSummary extends Component {
  
render() {
    const { activeButton } = this.props;
    return (
       <div style={{ all: 'unset' }}>
            {activeButton === 'about1' && (
                <div className="about-right-section-page summary-page">
                    <div className="about-right-section-text summary-text">
                    <h1>Summary</h1>
                        <div className="intro-summary">
                            <ul className="intro-summary-list">
                                <li>BA Computer Science </li>
                                <li>MA Transpersonal Psychology</li>
                                <li>Concentration in Creative Expression</li>
                                <li>Creativty Researcher</li>
                                <li>Expressive Arts Therapy Track</li>
                                <li>Holistic Perspectives</li>
                                <li>Environmental Science</li>
                                <li>Fostering Creativity</li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}
       </div> 
    );
  }
}

export default AboutSummary;